import EmailSend from './EmailSend';

export default EmailSend;
